import api from "./axiosConfig";

export interface DashboardInsightDto {
  title: string;
  message: string;
  type: string;
}

export interface RecentClientDto {
  id: string;
  name: string;
  currentScore: number;
  status: string;
  updatedAgo: string;
}

export interface DashboardSummaryResponse {
  activeClients: number;
  activeClientsAddedThisMonth: number;
  avgScoreGain: number;
  avgScoreGainVsLastMonth: number;
  itemsResolved: number;
  itemsResolvedThisWeek: number;
  monthlyRevenue: number;
  revenueGrowthPercent: number;
  recentClients: RecentClientDto[];
  insights: DashboardInsightDto[];
}

export const dashboardApi = {
  getSummary: () => api.get<DashboardSummaryResponse>("/dashboard/summary").then((r) => r.data),
};
